import { render, staticRenderFns } from "./Events__REMOVE.vue?vue&type=template&id=b9b995d2&scoped=true&lang=pug&"
import script from "./Events__REMOVE.vue?vue&type=script&lang=js&"
export * from "./Events__REMOVE.vue?vue&type=script&lang=js&"
import style0 from "./Events__REMOVE.vue?vue&type=style&index=0&id=b9b995d2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b995d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VImg,VRow})
